import { IProfile } from "@/interfaces/IProfile";
import AVATAR_MOCK from "@/public/images/mock/user_avatar.png";

export const USER: Pick<IProfile, "avatar_img" | "email" | "username"> = {
  username: "John Doe",
  email: "thebluesteyes@ai.com",
  avatar_img: AVATAR_MOCK.src,
};

export const TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Im1Aa29zLmNvLnRoIiwiaWQiOiI2MWIwYWYxMTM5MTE0YjQ5YTAwOTY2ZWYiLCJ1c2VyX2Zyb20iOiJwbGF0Zm9ybSIsInJvbGVfaWQiOiI2NWNhZjI0YzY2YTI0MTA5ZDFkNzZkYTkiLCJpYXQiOjE3MzgxNjcwNjIsImV4cCI6MTczODE2ODg2Mn0._A575JVQW-LFZ4pmvXSohGTwLQWnhVBvy8A0s7so40A";
